<template>
  <div class="whs-layout is-fullheight">
    <div class="whs-layout-row is-fullwidth">
      <Breadcrumbs :location="$store.state.location" />
    </div>
    <div class="whs-layout-row is-fullwidth">
      <div class="whs-sidebar">
        <Hero ref="hero" context="sidebar" />
        <ListFilter ref="filter" context="sidebar" v-show="hotels.length > 0" />
      </div>
      <div class="whs-content has-map is-fullheight">
        <HotelList ref="list" />
        <Map ref="map" v-if="region" />
        <!-- <div id="map"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Hero from '@/components/Hero.vue';
import HotelList from '@/components/HotelList.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';
import ListFilter from '@/components/ListFilter.vue';
import Map from '@/components/ListMap.vue';

export default {
  name: 'Hotels',
  components: {
    Hero,
    HotelList,
    Breadcrumbs,
    ListFilter,
    Map
  },
  computed: {
    ...mapState('hotels', ['hotels', 'region'])
  },
  mounted() {
    if (!this.$store.state.hero.direction) {
      setTimeout(() => {
        this.$store.dispatch('hero/setStateFromUri', this.$route.query).then(() => {
        this.$store
          .dispatch('hotels/getHotels', this.$route.query)
          .then(() => this.$store.dispatch('getLocation'));
        });
      }, 200);
    } else this.$store.dispatch('getLocation');
  }
};
</script>

<style scoped>
.has-map {
  display: flex;
  flex-grow: 999;
}
.is-fullwidth {
  max-width: unset;
}
.is-fullheight {
  min-height: 100vh;
}
</style>